import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "view-image"
}
const _hoisted_2 = { class: "view-box" }
const _hoisted_3 = { class: "close" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'image',
  props: {
    image: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (props.image)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, "x")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: props.image,
              alt: "View Image"
            }, null, 8, _hoisted_5)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})